// DOSSIERS INCERTAINS DE LA MIGRATION, CODE TEMPORAIRE : lien de la barre des Locations vers le document de relecture servi par GET /sales/rental_dossiers_incertains.
// Retrait : ce dossier + ses 3 lignes marquées dans rentals.ts/rentals.html (documentation.html#front.rental.dossiers-incertains).
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { environment } from '../../../../environments/environment';
import { AlertService } from '@app/shared/alert.service';

@Component({
  selector: 'app-dossiers-incertains',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <a mat-stroked-button class="btn-inline btn-ghost dossiers-incertains" href="" (click)="ouvrir($event)" title="Document de relecture des dossiers de location incertains de la migration (nouvel onglet)">
      <mat-icon>fact_check</mat-icon><span>Dossiers incertains</span>
    </a>
  `,
  styles: [`:host { align-self: flex-end; } .dossiers-incertains { white-space: nowrap; height: 28px; }`],
})
export class DossiersIncertainsComponent {
  private http = inject(HttpClient);
  private alertService = inject(AlertService);

  ouvrir(event: Event): void {
    event.preventDefault();
    // Onglet ouvert pendant le clic (sinon bloqué comme fenêtre surgissante), rempli quand le document arrive avec le jeton.
    const onglet = window.open('', '_blank');
    if (!onglet) {
      this.alertService.warn('Le navigateur a bloqué le nouvel onglet : autoriser les fenêtres surgissantes pour cette adresse.');
      return;
    }
    this.http.get(environment.server_url + '/sales/rental_dossiers_incertains', { responseType: 'text' }).subscribe({
      next: (html) => { onglet.location.href = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' })); },
      error: (e: HttpErrorResponse) => {
        onglet.close();
        this.alertService.error(typeof e.error === 'string' && e.error ? e.error : 'Document des dossiers incertains indisponible (' + e.status + ').');
      },
    });
  }
}
